import { render, staticRenderFns } from "./SensorStatus.vue?vue&type=template&id=b8588b5a&scoped=true"
import script from "./SensorStatus.vue?vue&type=script&lang=js"
export * from "./SensorStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8588b5a",
  null
  
)

export default component.exports